<template>
	<div class="m-portlet m-portlet--mobile m-portlet-incr-com">
		<div class="m-portlet__head row action-tools">
			<div class="col-2">
				<div class="input-group">
					<select id="filterChannelSelection" class="form-control">
					</select>
				</div>
			</div>
			<div class="col-5">
				<div class="form-group m--margin-top-10">
					<div class="m-checkbox-inline">
						<label class="m-checkbox">
							<input type="checkbox" value="2d" v-model="propFilter"> 2D
							<span></span>
						</label>
						<label class="m-checkbox">
							<input type="checkbox" value="3d" v-model="propFilter"> 3D
							<span></span>
						</label>
						<label class="m-checkbox">
							<input type="checkbox" value="4d" v-model="propFilter"> 4D
							<span></span>
						</label>
						<label class="m-checkbox">
							<input type="checkbox" value="da" v-model="propFilter"> Đá
							<span></span>
						</label>
					</div>
				</div>
			</div>
			<div class="col-5">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text">Tìm:</span>
					</div>
					<input id="number_search" v-model="numberSearch" type="text" class="form-control m-input" placeholder="Nhập số">
				</div>
			</div>
		</div>
		<div class="m-portlet__body row table-content">
			<div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4" v-if="propFilter.indexOf('2d') >= 0">
				<lock-number-table
					title="2D" 
					type="2d" 
					:currentGame="currentGame" 
					:comms="locks['2d']"
					:dataKey="{parent: 'parentLock', child: 'childLock', user: 'userLock', data: 'limit'}"
					v-on:number-add-click="onAddOrUpdateLockNumber"
				></lock-number-table>
			</div>
			<div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4" v-if="propFilter.indexOf('3d') >= 0">
				<lock-number-table
					title="3D" 
					type="3d" 
					:currentGame="currentGame" 
					:comms="locks['3d']"
					:dataKey="{parent: 'parentLock', child: 'childLock', user: 'userLock', data: 'limit'}"
					v-on:number-add-click="onAddOrUpdateLockNumber"
				></lock-number-table>
			</div>
			<div class="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2" v-if="propFilter.indexOf('4d') >= 0">
				<lock-number-table
					title="4D" 
					type="4d" 
					:currentGame="currentGame" 
					:comms="locks['4d']"
					:dataKey="{parent: 'parentLock', child: 'childLock', user: 'userLock', data: 'limit'}"
					v-on:number-add-click="onAddOrUpdateLockNumber"
				></lock-number-table>
			</div>
			<div class="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2" v-if="propFilter.indexOf('da') >= 0">
				<lock-number-table
					title="Đá" 
					type="da" 
					:currentGame="currentGame" 
					:comms="locks['da']"
					:dataKey="{parent: 'parentLock', child: 'childLock', user: 'userLock', data: 'limit'}"
					v-on:number-add-click="onAddOrUpdateLockNumber"
				></lock-number-table>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import GameInfoSelection from './GameInfoSelection';
	import groupBy from 'lodash/groupBy';
	import sortBy from 'lodash/sortBy';
	import NumberTable from '../NumberTable';
	import { Utilities } from '../../utilities';

	export default {
		data(){
			let vm = this;

	        return {
	        	"originLocks": [],
	        	"locks": { "2d":[], "3d":[], "4d":[], "da":[] },
				"currentGame": "1",
				"propFilter": ["2d", "3d", "4d", "da"],
				"channelsToday": [],
				"numberSearch": "",

	            "today": moment().format('DD/MM/Y'),
	        }
	    },

	    components: {
        	'game-info-selection': GameInfoSelection,
        	'lock-number-table': NumberTable
        },

	    created(){
    		this.getLockNumber();
    	},

		mounted(){
	    	this.initScript();
	    	let channelsToday = this.getchannelsToday();
	    	$("#filterChannelSelection").select2({data: channelsToday, width:"100%"});
	    },

	    watch: {
	    	originLocks: function(locks){
	    		this.locks = this.groupCommByProp(locks);
	    		if($("#filterChannelSelection").val() == ""){
	    			$("#filterChannelSelection").val(parseInt($("#filterChannelSelection option:eq(0)").val())).trigger('change.select2');
	    		}else{
	    			$("#filterChannelSelection").trigger('change.select2');
	    		}
	    	},
	    	numberSearch: function(n){
	    		this.filterByNumber(n);
	    	}
	    },

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

	    methods: {
	    	initScript: function(){
	    		let vm = this;

				$("#filterChannelSelection").on("change.select2", function(e){
					if(!$(this).select2('data')[0]) return;

					let game = $(this).select2('data')[0].gameId;
					let channel = $(this).val();
					vm.currentGame = parseInt(game);
					let data = vm.originLocks.filter(function(el){
						let elc = el.channel.split(".");
						return elc.includes(channel);
					});
					vm.locks = vm.groupCommByProp(data);
				});
	    	},
	    	getchannelsToday: function() {
	    		let vm = this;
				let ccc = [];
				for(let game in this.gameInfo.channelToday){
					if(game == 3) continue;

					let cs = this.gameInfo.channelToday[game].map((el) => {
        				return { id: el.channel_id, text: vm.gameInfo.channels[parseInt(el.channel_id)].alias, gameId: game };
        			});

        			ccc = ccc.concat(cs);
				}

				return ccc;
			},

			channelToName: function(channel){
				let vm = this;
				if(channel.indexOf(".") >= 0){
					let chns = channel.split(".").map((cns) => { return vm.gameInfo.channels[parseInt(cns)].alias; });
        			return chns.join(", ");
				}

				return vm.gameInfo.channels[parseInt(channel)].alias;
			},

	    	groupCommByProp: function(locks){
	    		let commission = {};
	    		let vm = this;

	    		locks = groupBy(locks, function(val){
	    			return Utilities.propGroupToName(val.prop);
	    		});

	    		for(let prop in locks){
	    			if(!commission[prop]) commission[prop] = [];

	    			let gcns = groupBy(locks[prop], function(val){ return val.game+"_"+val.channel+"_"+val.number; });
	    			for(let gcn in gcns){
	    				let number = gcn.split("_")[2];
	    				let propComm = groupBy(gcns[gcn], function(val){ return val.prop; });

    					commission[prop].push({
		    				"number": number,
		    				"comm": propComm
		    			});
	    			}
	    		}

	    		for(let prop in commission){
	    			let arr = sortBy(commission[prop], function(o) { return o.number; })
	    			commission[prop] = arr;
	    		}

	    		return commission;
	    	},
	    	generateChannelToday: function(game){
	        	let vm = this;
	        	let data = [];

	        	if(game == 3){
        			data = vm.gameInfo.channelToday[game].map((el) => {
        				let chns = el.channel_id.split(".").map((cns) => { return vm.gameInfo.channels[parseInt(cns)].alias; });
        				return { id: el.channel_id, text: chns.join(", ") };
        			});
        		}else{
        			data = vm.gameInfo.channelToday[game].map((el) => {
        				return { id: el.channel_id, text: vm.gameInfo.channels[parseInt(el.channel_id)].alias };
        			});
        		}

        		data.unshift({"id": "", "text": ""});
        		return data;
	        },

	        filterByNumber: function(val){
	        	let vm = this;
	        	let channel = $("#filterChannelSelection").val();

	        	let filterd = this.originLocks.filter(function(el){
	        		let elc = el.channel.split(".");
					return elc.includes(channel);
	        	});

	        	if(val == "") {
					vm.locks = vm.groupCommByProp(filterd);
	        		return;
	        	}

	        	filterd = filterd.filter(function(el){
	        		if(el.number.includes(".")){
	        			return el.number.includes(val);
	        		}

	        		return el.number == val;
	        	});

	        	vm.locks = vm.groupCommByProp(filterd);
	        },
	        onMoreCommTab: function(){
	        	this.khoaSoFormTabs++;
	        },

	        getLockNumber: function(){
	        	let vm = this;

	        	window.axios.get("admin-panel/tools/lock-number")
	        				.then((res) => {
	        					res = res.data;
	        					vm.originLocks = res.data;
	        				})
	        				.catch((error) => {

	        				});
	        },

	        showKhoaSoForm: function() {
	        	let vm = this;

	        	this.displayKhoaSoForm = true;

	        	$("#khoaSoForm").on('hidden.bs.modal', function () {
	        		vm.displayKhoaSoForm = false;
	        		vm.khoaSoFormTabs = 1;
				});
	        	$("#khoaSoForm").modal('show');
	        	
            	$(".game-select").select2({placeholder:"Miền"});
				$(".channel-select").select2({placeholder:"Đài"});
				$(".prop-select").select2({placeholder:"Kiểu"});

	        },

	        lockNumber: function(){
	        	let vm = this;

        		let data = [];
        		let forms = $(".tab-pane form");
        		for(let i=0;i<forms.length;i++){
        			let limit = $(forms[i]).find(".limit").val();
        			let channel = $(forms[i]).find(".channelSelection").val();
        			let prop = $(forms[i]).find(".propSelection").val();
        			let game = $(forms[i]).find(".gameSelection").val();
        			let number = $(forms[i]).find(".number").val();
        			let code = $(forms[i]).find(".subCode").val();

        			if(number == ""){
        				swal("Lỗi", "Số không được bỏ trống!", "error");
        				return;
        			}

        			if(game == ""){
        				swal("Lỗi", "Vui lòng chọn game!", "error");
        				return;
        			}

        			if(limit == ""){
        				swal("Lỗi", "Mục nhập điểm giới hạn không được để trống!", "error");
        				return;
        			}

        			if(code.indexOf(vm.user.code) > 0 && vm.user.role != "admin" && (code.length - vm.user.code.length != 2)){
        				swal("Lỗi", "Không thể khóa số cho cấp dưới " + code, "error");
        				return;
        			}

        			data.push({
        				game: parseInt(game),
        				channel: channel.join(","),
        				prop: prop.join(","),
        				number: number,
        				code: code,
        				limit: parseInt(limit)
        			});
        		}

        		window.axios.post("admin-panel/tools/lock-number", { "locks": data })
			    .then((response) => {
			    	if(response.data.code == 1){
			    		let c = vm.channelToName(response.data.data.channel_id);
			    		let g = vm.gameInfo.games[response.data.data.game_id];
			    		let p = vm.gameInfo.props[response.data.data.prop_id];
			    		let msg = g + ", " +c+ ", " +p+" - số " + response.data.data.number + ", khóa hiện tại " + response.data.data.locked + " " +response.data.msg.toLowerCase();
			    		swal("", msg, "error");
			    		return;
			    	}

			    	if(response.data.code == 0){
			    		swal("", "Khóa số thành công", "success");
			    		vm.getLockNumber();
			    		$("#khoaSoForm").modal('hide');
			    	}
			    })
			    .catch((error) => { });
	        },

	        onAddOrUpdateLockNumber: function({data, callback}){
	        	let vm = this;
	        	axios.post("admin-panel/tools/lock-number", { "locks": data })
				    .then((response) => {
				    	if(response.data.code == 1){
				    		let c = vm.channelToName(response.data.data.channel_id);
				    		let g = vm.gameInfo.games[response.data.data.game_id];
				    		let p = vm.gameInfo.props[response.data.data.prop_id];
				    		let msg = g + ", " +c+ ", " +p+" - số " + response.data.data.number + ", khóa hiện tại " + response.data.data.locked + " " +response.data.msg.toLowerCase();
				    		swal("", msg, "error");
				    		return;
				    	}
				    	if(response.data.code == 0){
				    		swal("", "Khóa số thành công", "success");
				    		callback();
				    		vm.getLockNumber();
				    	}
				    })
				    .catch((error) => { });
	        }
	    }
	}

</script>